import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';
import { loadUserSettings } from '~src/services/api/user';
import { DbUserSettings } from '~src/types/db';

const FIVE_MINUTES = 5 * 60 * 1000;

const shouldRetry = (err: any) => {
  const status = err?.response?.status;
  if (status === 401 || status === 403) return false;
  return true;
};

export const useUserSettings = (
  queryConfig: QueryConfig<DbUserSettings, AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const userQuery = useQuery<DbUserSettings, AxiosError>(
    ['userSettings'],
    loadUserSettings,
    {
      staleTime: FIVE_MINUTES,
      refetchInterval: FIVE_MINUTES,
      refetchOnMount: false,
      refetchOnWindowFocus: !__DEV__,

      enabled: enabledOverwrite,

      retry: (failureCount: number, err: any) => {
        if (!shouldRetry(err)) return false;
        return failureCount < 2;
      },

      ...options,
    }
  );

  return userQuery;
};

export const useIsUserAuthenticated = () => {
  const { data, error } = useUserSettings();

  if (error) {
    if (error.response?.status === 401 || error.response?.status === 403) {
      return false;
    }
  }

  return Boolean(data);
};
